<template>
    <div class="main-wrapper">
        <el-row type="flex" class="mb-1 align-center">
            <b class="section-subheader">SMS Logging Preferences</b>
        </el-row>
        <el-row>
            <span>Customize SMS logging preferences for seamless integration between {{ integrationNameWithCasing }} and {{ staticName }}.</span>
        </el-row>
        <el-row>
            <span>Select logging levels tailored to your organizations requirements.</span>
        </el-row>

        <el-row :gutter="20" class="mt-3">
            <!-- Start Aloware and HubSpot Labels -->
            <el-col :span="9" class="mb-1">
                <small>{{ staticName }}</small>
            </el-col>
            <el-col :span="4" class="mb-1 text-center">
                <small>Direction</small>
            </el-col>
            <el-col :span="9" class="mb-1">
                <small>{{ integrationNameWithCasing }}</small>
            </el-col>
            <el-col :span="2">
                <!-- No label for the toggle switch -->
            </el-col>
            <!-- End Aloware and HubSpot Labels -->
        </el-row>

        <el-row v-for="(operation, index) in model.settings.mapper_settings.sms" :key="operation.internal_value + '-' + index" :gutter="20" type="flex" align="middle" class="mb-3">
            <!-- Start Aloware Fields -->
            <el-col :span="9">
                <el-input
                    readonly
                    :disabled="!operation.enabled"
                    :value="operation.internal_label"
                    class="w-100"
                />
            </el-col>
            <!-- End Aloware Fields -->

            <el-col :span="4" class="text-center">
                <el-tooltip
                    v-if="operation.direction_fixed"
                    content="Direction on Contact Syncing Prefences cannot be changed"
                    placement="top"
                    effect="dark"
                >
                    <direction-selector
                        :initial-state="operation.direction"
                        @change="direction => updateDirection(index, direction)"
                        :disabled="!operation.enabled || operation.direction_fixed"
                    >
                    </direction-selector>
                </el-tooltip>
                <direction-selector
                    v-else
                    :initial-state="operation.direction"
                    @change="direction => updateDirection(index, direction)"
                    :disabled="!operation.enabled || operation.direction_fixed"
                >
                </direction-selector>
            </el-col>

            <!-- Start CRM Fields -->
            <el-col :span="9">
                <el-input
                    readonly
                    :value="operation.crm_label"
                    :disabled="!operation.enabled"
                    class="w-100"
                />
            </el-col>
            <!-- End CRM Fields -->

            <!-- Start Enable Switch -->
            <el-col :span="2" class="text-center">
                <el-tooltip
                    v-if="isLastEnabledOperation(index)"
                    content="At least one SMS logging preference should be enabled."
                    placement="top"
                    effect="dark"
                >
                    <el-switch
                        v-model="operation.enabled"
                        active-color="#00a344"
                        :disabled="isLastEnabledOperation(index)"
                        @change="handleSwitchChange(index, $event)"
                    >
                    </el-switch>
                </el-tooltip>
                <el-switch
                    v-else
                    v-model="operation.enabled"
                    active-color="#00a344"
                    @change="handleSwitchChange(index, $event)"
                >
                </el-switch>
            </el-col>
            <!-- End Enable Switch -->
        </el-row>
    </div>
</template>

<script>
import DirectionSelector from '../direction-selector.vue'

export default {
    components: {
        DirectionSelector,
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        staticName: {
            type: String,
            required: true
        }
    },
    computed: {
        enabledOperationsCount() {
            return this.model.settings.mapper_settings.sms.filter(op => op.enabled).length
        }
    },
    methods: {
        updateDirection(index, direction) {
            this.model.settings.mapper_settings.call[index].direction = direction
        },
        isLastEnabledOperation(index) {
            return this.enabledOperationsCount === 1 && this.model.settings.mapper_settings.sms[index].enabled
        },
        handleSwitchChange(index, value) {
            if (!value && this.isLastEnabledOperation(index)) {
                // Prevent disabling the last enabled operation
                this.model.settings.mapper_settings.sms[index].enabled = true
            }
        }
    }
}
</script>

<style scoped>
.main-wrapper {
    width: 100%;
}

.section-subheader {
    font-size: 16px;
}

.w-100 {
    width: 100%;
}

.align-center {
    align-items: center;
}
</style>
